// Context chips row: pill chips with an icon and an optional bold value (document, version, status), as in the workspace header.
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export function ContextChips({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("flex flex-wrap gap-1.5", className)}>{children}</div>;
}

interface ContextChipProps {
  icon?: LucideIcon;
  children: ReactNode;
  value?: ReactNode;
  className?: string;
}

export function ContextChip({ icon: Icon, children, value, className }: ContextChipProps) {
  return (
    <span
      className={cn(
        "inline-flex h-[26px] items-center gap-1.5 rounded-pill border bg-card px-2.5 text-xs whitespace-nowrap text-ink-2",
        className,
      )}
    >
      {Icon ? <Icon aria-hidden className="size-3.5 text-muted-foreground" /> : null}
      {children}
      {value === undefined ? null : <b className="font-semibold text-brand-blue">{value}</b>}
    </span>
  );
}
